// extracted by mini-css-extract-plugin
module.exports = {"searchDiv":"Search_searchDiv__3A8Zh"};